import React from 'react';
import ServiceStatusDoughnutChart from './ServiceStatusDoughnutChart';
import { Typography } from '@mui/material';

const StatusChart = ({ data }) => {

  return (
    <div className="alert-chart">
      <Typography sx={{ fontSize: 24, color: 'gray', fontWeight: 'bold' }}>Resumen gráfico de Estado</Typography>
      
      <div className="chart">
        <ServiceStatusDoughnutChart
          data={data}
        />
      </div>
    </div>
  );
};

export default StatusChart;
